// Generated from SVG to Code Figma Plugin

export const BaseLineFreeCrop = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17 1V17H1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    <path d="M1 17V1L17 1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    <path
      d="M10.1426 5.57568L12.4283 5.57175L12.4322 7.85746"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M7.86191 12.4287L5.5762 12.4327L5.57227 10.147"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
